import { render, staticRenderFns } from "./DevicesNotification.vue?vue&type=template&id=65740af0&scoped=true"
import script from "./DevicesNotification.vue?vue&type=script&lang=ts"
export * from "./DevicesNotification.vue?vue&type=script&lang=ts"
import style0 from "./DevicesNotification.vue?vue&type=style&index=0&id=65740af0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65740af0",
  null
  
)

export default component.exports